var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4844 0H3.51562C1.57709 0 0 1.57709 0 3.51562V20.4844C0 22.4229 1.57709 24 3.51562 24H20.4844C22.4229 24 24 22.4229 24 20.4844V3.51562C24 1.57709 22.4229 0 20.4844 0ZM22.5938 20.4844C22.5938 21.6475 21.6475 22.5938 20.4844 22.5938H3.51562C2.35254 22.5938 1.40625 21.6475 1.40625 20.4844V3.51562C1.40625 2.35254 2.35254 1.40625 3.51562 1.40625H20.4844C21.6475 1.40625 22.5938 2.35254 22.5938 3.51562V20.4844Z",
    fill: "#363853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5197 9.84375C15.5184 9.84375 15.5169 9.84375 15.5156 9.84375C15.0295 9.84375 14.556 9.92505 14.1094 10.0829V9.84375H9.89062V19.7812H14.1094V14.7656C14.1094 14.378 14.4249 14.0625 14.8125 14.0625C15.2001 14.0625 15.5156 14.378 15.5156 14.7656V19.7812H19.7344V14.2822C19.7344 12.0066 17.8883 9.84595 15.5197 9.84375ZM18.3281 18.375H16.9219V14.7656C16.9219 13.6025 15.9756 12.6562 14.8125 12.6562C13.6494 12.6562 12.7033 13.6025 12.7031 14.7654V18.375H11.2969V11.25H12.7031V12.6572L13.8285 11.812C14.3179 11.4443 14.9013 11.25 15.5156 11.25H15.5184C17.0151 11.2515 18.3281 12.6683 18.3281 14.2822V18.375Z",
    fill: "#363853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26562 19.7812H8.48438V9.84375H4.26562V19.7812ZM5.67188 11.25H7.07812V18.375H5.67188V11.25Z",
    fill: "#363853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26562 8.4375H8.48438V4.21875H4.26562V8.4375ZM5.67188 5.625H7.07812V7.03125H5.67188V5.625Z",
    fill: "#363853"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.931417ee21fba406be2f418b241f0642.svg";
export { ForwardRef as ReactComponent };